import React, {createContext, useEffect, useReducer, useContext} from 'react';
import {useLocation, Navigate} from 'react-router-dom';
import {
  getRegistrationToken,
  getScannedDeviceInfo,
  registerVenue,
} from '../../api';
import {useApp} from '../AppContext';

const RegistrationContext = createContext();

const initialState = {
  step: 0,
  registration_token: null,
  scanned_device: null,
  venue: {
    country: '',
    area: '',
    name: '',
    zipcode: '',
    address: '',
    phone: '',
    website: '',
  },
  rooms: [
    {
      new_room_id: 1,
      name: 'MAIN',
    },
  ],
  devices: [
    {
      new_room_id: 1,
      customer_id: '',
      device_name: '',
      image_url: '',
      serial_code: '',
      scanned: false,
      valid: false,
      is_others: false,
    },
  ],
};

function reducer(state, action) {
  console.log(state, action);
  switch (action.type) {
    case 'signin': {
      return {
        ...state,
        registration_token: action.registration_token,
      };
    }
    case 'clear_scanned_device': {
      return {
        ...state,
        scanned_device: null,
        devices: JSON.parse(JSON.stringify(initialState.devices)),
      };
    }
    case 'set_scanned_device': {
      return {
        ...state,
        scanned_device: action.device,
        devices: [
          {
            new_room_id: 1,
            customer_id: action.device.customer_id,
            device_name: action.device.device_name,
            image_url: action.device.image_url,
            serial_code: action.device.serial_code,
            scanned: true,
            valid: true,
            is_others: action.device.is_others,
          },
        ],
      };
    }
    case 'signout': {
      return {
        ...state,
        registration_token: null,
      };
    }
    case 'set_default_country': {
      const venue = {
        ...state.venue,
        country: action.country,
        area: '',
      };
      return {
        ...state,
        venue,
      };
    }
    case 'step1': {
      return {
        ...state,
        step: 1,
      };
    }
    case 'set_venue': {
      return {
        ...state,
        venue: action.venue,
      };
    }
    case 'step2': {
      return {
        ...state,
        step: 2,
      };
    }
    case 'set_rooms': {
      return {
        ...state,
        rooms: action.rooms,
      };
    }
    case 'step3': {
      return {
        ...state,
        step: 3,
      };
    }
    case 'set_devices': {
      return {
        ...state,
        devices: action.devices,
      };
    }
    default:
      throw new Error(`${action.type} is not defined.`);
  }
}

export const RegistrationContextProvider = ({api, children}) => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const app = useApp();

  useEffect(() => {
    dispatch({
      type: 'clear_scanned_device',
    });
    const searchParams = new URLSearchParams(window.location.search);
    let customer_id = searchParams.get('customer_id');
    let serial_code = searchParams.get('serial');
    if (!serial_code ||
        !/^[0-9a-z]{12}$/i.test(serial_code)
    ) {
      serial_code = '';
    } else {
      serial_code = serial_code.toUpperCase();
    }
    if (customer_id && /^[0-9a-f]{15}$/i.test(customer_id)) {
      (async () => {
        window.incrementLoading();

        try {
          let device = await getScannedDeviceInfo({
            customer_id: customer_id.toUpperCase(),
          });
          if (device && device.device_name) {
            dispatch({
              type: 'set_scanned_device',
              device: {
                ...device,
                serial_code,
              },
            });
          }
          console.log(device);
        } catch (e) {
          console.error(e);
        }
        window.decrementLoading();
      })();
    }
  }, []);

  let validate = async (customer_id) => {
    try {
      //      window.incrementLoading();
      let device = await getScannedDeviceInfo({
        customer_id: customer_id.toUpperCase(),
      });
      //      window.decrementLoading();
      return device || null;
    } catch (e) {
      //      window.decrementLoading();
      throw e;
    }
  };

  let signin = async (email, password, callback) => {
    try {
      window.incrementLoading();
      let result = await getRegistrationToken({email, password});
      //let result = {
      //  registration_token: "TEST"
      //}
      dispatch({
        type: 'signin',
        registration_token: result.registration_token,
      });
      window.clearLoading();
      callback();
    } catch (e) {
      window.clearLoading();
      callback(e);
    }
  };

  let signout = (callback) => {
    dispatch({
      type: 'signout',
    });
    callback && callback();
  };

  let isLoggedIn = () => {
    return !!state.registration_token;
  };

  let doRegister = async () => {
    let data = {
      venue: state.venue,
      rooms: state.rooms,
      devices: state.devices.filter(d => d.valid),
    };
    try {
      window.incrementLoading();
      //throw new Error("TEST ERROR");

      let result = await registerVenue({
        data,
        registrationToken: state.registration_token,
      });
      /*
      let result = {
        token_type: "bearer",
        access_token:
          "MOOZULupj7dFRPMIrJ1Qfjo8D4IcPCri608tbIpmuIT64qfbxKCJsP4Uym2T40VWSTNxBC2r4O9DWesvKBvfoFGFoqiBtedoVb_sjO-hZI3V",
        expires_in: 2592000,
        venue_code: "V2p7aLn",
        name: "My New Venue",
        result: true,
        code: 0,
        info: {
          token: {
            token_type: "bearer",
            registration_token:
              "xXQn2Mq4nJqJTzSxTh_zLzpVLvIt0D4ULnsWkNPCrCeCCdhi3EJdz9Q7KlW97IzTc-UXKveaHfkJl-YigpGil9VDo3GBhw8WXMnoYxIzNLXJKnbczjjnY6SUiotLjqLlFA",
            expires_in: 2592000,
          },
          total_ms: 630,
          ex_api_ms: 0,
        },
      };
      */
      window.clearLoading();
      return result;
    } catch (e) {
      window.clearLoading();
      throw e;
    }
  };
  /*
  {
    "venue": {
      "country": "JP",
      "area":"JP-40",
      "name": "xbs_test3",
      "zipcode" :"123546",
      "address":"addressss",
      "phone":"123445",
      "website":"https://www.test.com/"
    },
    "rooms":[{
      "new_room_id":0,
      "name":"MAIN"
    },{
      "new_room_id":1,
      "name":"SUB"
    }],
    "devices":[{
      "new_room_id": 0,
      "customer_id":"0000C8A9F1F1070"
    }]
  }
*/

  if (app.state.viewer && app.state.viewer.country && !state.venue.country) {
    dispatch({
      type: 'set_default_country',
      country: app.state.viewer.country,
    });
  }

  const value = {
    state,
    dispatch,
    signin,
    signout,
    isLoggedIn,
    validate,
    doRegister,
  };

  return (
      <RegistrationContext.Provider value={value}>
        {children}
      </RegistrationContext.Provider>
  );
};

export const useRegistration = () => {
  return useContext(RegistrationContext);
};

export default RegistrationContext;
